import { render, staticRenderFns } from "./self_diagnosis_symptom.vue?vue&type=template&id=1de68cf3&scoped=true"
import script from "./self_diagnosis_symptom.vue?vue&type=script&lang=js"
export * from "./self_diagnosis_symptom.vue?vue&type=script&lang=js"
import style0 from "./self_diagnosis_symptom.vue?vue&type=style&index=0&id=1de68cf3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de68cf3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1de68cf3')) {
      api.createRecord('1de68cf3', component.options)
    } else {
      api.reload('1de68cf3', component.options)
    }
    module.hot.accept("./self_diagnosis_symptom.vue?vue&type=template&id=1de68cf3&scoped=true", function () {
      api.rerender('1de68cf3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/knowledge/self_diagnosis_symptom.vue"
export default component.exports